/**
 * Evergreen offer countdown for the product page.
 *
 * Each visitor gets a full cycle from the moment they land; the deadline is kept
 * in sessionStorage so it keeps running across page views instead of restarting
 * on every navigation. When it hits zero it restarts by itself.
 *
 * The theme already ships a <countdown-timer> (secondary.js) used by the cart
 * drawer, but it is MM:SS only and resets to a hardcoded 90s, hence this one.
 */
(function () {
  var DEFAULT_MINUTES = 120;
  var STORAGE_PREFIX = 'offer-countdown:';

  function pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  function readDeadline(key) {
    try {
      return parseInt(window.sessionStorage.getItem(key), 10);
    } catch (e) {
      return NaN;
    }
  }

  function writeDeadline(key, value) {
    try {
      window.sessionStorage.setItem(key, String(value));
    } catch (e) {
      // Private mode / storage blocked: the timer still runs, it just restarts
      // on every page load instead of carrying over.
    }
  }

  class OfferCountdown extends HTMLElement {
    connectedCallback() {
      var minutes = parseFloat(this.dataset.minutes);
      if (!minutes || minutes <= 0) minutes = DEFAULT_MINUTES;
      this.durationMs = minutes * 60 * 1000;

      // Duration is part of the key, so changing it in the theme editor
      // invalidates the old deadline and starts a clean cycle.
      this.storageKey = STORAGE_PREFIX + (this.dataset.key || 'default') + ':' + this.durationMs;

      this.hoursEl = this.querySelector('[data-unit="hours"]');
      this.minutesEl = this.querySelector('[data-unit="minutes"]');
      this.secondsEl = this.querySelector('[data-unit="seconds"]');
      if (!this.hoursEl || !this.minutesEl || !this.secondsEl) return;

      var stored = readDeadline(this.storageKey);
      this.deadline = stored && stored > Date.now() ? stored : this.restart();

      this.boundTick = this.tick.bind(this);
      this.tick();
      this.timerId = setInterval(this.boundTick, 1000);
      // Re-sync after the tab was backgrounded (throttled intervals drift).
      document.addEventListener('visibilitychange', this.boundTick);
    }

    disconnectedCallback() {
      clearInterval(this.timerId);
      document.removeEventListener('visibilitychange', this.boundTick);
    }

    restart() {
      this.deadline = Date.now() + this.durationMs;
      writeDeadline(this.storageKey, this.deadline);
      return this.deadline;
    }

    tick() {
      var remaining = this.deadline - Date.now();
      if (remaining <= 0) {
        remaining = this.restart() - Date.now();
      }

      var totalSeconds = Math.ceil(remaining / 1000);
      this.hoursEl.textContent = pad(Math.floor(totalSeconds / 3600));
      this.minutesEl.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      this.secondsEl.textContent = pad(totalSeconds % 60);
    }
  }

  if (!window.customElements.get('offer-countdown')) {
    window.customElements.define('offer-countdown', OfferCountdown);
  }
})();
